import apiClient from './client';

const buildHeaders = (token = null) => {
  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

const normalizeAdsError = (error, fallbackCode) => {
  const detail = error?.response?.data?.detail;
  if (detail && typeof detail === 'object' && !Array.isArray(detail)) {
    return {
      error_code: detail.error_code || fallbackCode,
      message: detail.message || 'Errore durante la gestione dell\'annuncio premio.',
      state: detail.state || 'unavailable',
    };
  }

  return {
    error_code: fallbackCode,
    message: error?.response?.data?.message || error?.message || 'Errore durante la gestione dell\'annuncio premio.',
    state: 'unavailable',
  };
};

export const getRewardedAdStatus = async (token = null) => {
  const response = await apiClient.get('/ads/reward-status', {
    headers: buildHeaders(token),
  });
  return response.data;
};

export const createRewardedAdIntent = async ({ sourceSurface, gameSlug = null }, token = null) => {
  try {
    const response = await apiClient.post(
      '/ads/reward-intent',
      {
        source_surface: sourceSurface,
        game_slug: gameSlug,
      },
      { headers: buildHeaders(token) },
    );
    return response.data;
  } catch (error) {
    throw normalizeAdsError(error, 'REWARDED_AD_INTENT_FAILED');
  }
};

export const claimRewardedAd = async (intentToken, token = null) => {
  try {
    const response = await apiClient.post(
      '/ads/reward-claim',
      { intent_token: intentToken },
      { headers: buildHeaders(token) },
    );
    return response.data;
  } catch (error) {
    throw normalizeAdsError(error, 'REWARDED_AD_CLAIM_FAILED');
  }
};
